import styled, { css } from 'styled-components';
import { Button } from 'components/Button';
import { ButtonBaseProps } from 'components/Modal/styles';
import { isMobile } from 'utils';

export const SearchWrapper = styled.div`
  width: 35vw;
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--v3-white);
  border-radius: 20px;
  margin-bottom: 5px;

  ${isMobile() &&
  css`
    width: 96vw;
    top: 30%;
  `}

  & .ant-input-group-wrapper {
    background: var(--v3-black-6);
    border-radius: 16px;
    padding: 8px 12px;
    width: ${isMobile() && `91vw`};
  }

  && .ant-input-group-addon {
    border-radius: 12px;
    background: var(--v3-black-0);
    border: none;
    box-shadow: 0px 3px 3px rgba(119, 110, 171, 0.08);
  }

  & .ant-select-selection-item {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: var(--v3-text-color);
  }

  &&& .ant-input {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    color: var(--v3-text-color);
    margin-left: 12px;
    background: none;
    &:hover {
      background: none;
    }
  }

  & .ant-select-arrow {
    color: var(--v3-text-color);
  }
`;

export const SearchTitleWrapper = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
`;
export const SearchTitle = styled.div`
  font-weight: 800;
  font-size: 22px;
  line-height: 28px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SearchResults = styled.div`
  z-index: 9999;
  width: 100%;
  height: 80vh;
  border: 1px solid var(--v3-black-2);
  box-shadow: 0 16px 33px rgba(119, 110, 171, 0.11);
  border-radius: 20px;
  padding: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-content: center;
  background: var(--v3-white);
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  ${isMobile() &&
  css`
    width: 92vw;
    top: 100%;
    position: relative;
    left: 1.5vw;
    height: 29vh;
  `}
`;

export const CategoryHeader = styled.h3`
  margin: 0;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  text-align: left;
`;

export const CollectionCounter = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
`;

export const CancelButton = styled(Button)`
  &&& {
    border: none;
  }
`;

export const EmptyWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  background: var(--v3-white);
  border: 1px solid var(--v3-black-2);
  border-radius: 20px;

  .ant-empty-description {
    color: var(--v3-text-color);
  }
  ${isMobile() &&
  css`
    box-shadow: 0 16px 33px rgba(119, 110, 171, 0.11);
    position: relative;
    top: 29vh;
    width: 93vw;
    left: 1vw;
  `}
`;

export const Portal = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CloseButton = styled.button<ButtonBaseProps>`
  position: absolute;
  background: var(--v3-black-4);
  color: var(--v3-text-color);
  border-radius: 50%;
  top: 15px;
  right: 14px;
  width: 30px;
  height: 30px;
  font-size: 22px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 51;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;
